import Entity from '../../../../../../foundation/domain/Entity';
import EntityId from '../../../../../../foundation/domain/EntityId';
import User from '../../../../users/domain/aggregates/user/User';
import Timepoint from '../../../../../../foundation/time/Timepoint';
import Lesson from '../lesson/Lesson';

export default class LessonResult extends Entity<LessonResult> {

	public constructor (id: EntityId<LessonResult>, private userId: EntityId<User>, private lessonId: EntityId<Lesson>, private progress: number, private completedTimepoint: Timepoint | null) {
		super(id);
	}

	public getUserId () {
		return this.userId;
	}

	public getLessonId () {
		return this.lessonId;
	}

	public getProgress () {
		return this.progress;
	}

	public getCompletedTimepoint () {
		return this.completedTimepoint;
	}

	public isCompleted () {
		return this.completedTimepoint !== null;
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/aggregates/lessonResult/LessonResult.ts